/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Payments_Delete_ConfirmInputs */

const cs_deal_payments_delete_confirm = /** @type {(inputs: Deal_Payments_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazat tuto platbu?`)
};

const en_deal_payments_delete_confirm = /** @type {(inputs: Deal_Payments_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this payment?`)
};

/**
* | output |
* | --- |
* | "Delete this payment?" |
*
* @param {Deal_Payments_Delete_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_payments_delete_confirm = /** @type {((inputs?: Deal_Payments_Delete_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Payments_Delete_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_payments_delete_confirm(inputs)
	return cs_deal_payments_delete_confirm(inputs)
});